import whatsImg from '../../img/whats.svg';
import mailImg from '../../img/email.svg';
import './style.css';
import clsx from 'clsx';
import {
  supplierSupportWhatsappURL,
  supportWhatsappNumberDisplay,
} from '../../utils/whatsapp';
import { inventa_contact_email } from 'src/constants/inventa_contact';

function FooterSuporte({ className = '', children }) {
  return (
    <div
      className={clsx('container border-top my-5 pt-2 shrink-basis', className)}
    >
      {children}
      <div className="row justify-content-around w-100 m-0">
        <div className="col-12 col-lg-4 my-2 d-flex flex-column justify-content-center align-items-center">
          <div className="col-12 pr-md-5 ml-md-2">
            <span className="d-block fs-4 fw-normal text-black-50">
              Ficou com dúvida?
            </span>
            <p className="paragraph-faleconosco fw-light">
              Entre em contato com nosso suporte
            </p>
          </div>
        </div>

        <div className="col-12 col-lg-4 my-2 d-flex row">
          <div className="col-4 col-lg-4 d-flex align-items-center justify-content-center my-2">
            <a
              href={supplierSupportWhatsappURL}
              target="_blank"
              rel="noreferrer"
            >
              <div
                id="icons-container"
                className="container-img-faleconosco d-flex align-items-center justify-content-center"
              >
                <img
                  src={whatsImg}
                  className="icons d-flex align-self-center"
                  alt="WhatsApp icon"
                />
              </div>
            </a>
          </div>

          <div className="col-7 my-2 d-flex pl-1 flex-column justify-content-center align-items-start">
            <h3 className="subtitle-suporte d-block fs-4 fw-light text-black-50">
              WhatsApp
            </h3>
            <a
              href={supplierSupportWhatsappURL}
              target="_blank"
              rel="noreferrer"
              className="text-decoration-none"
            >
              <h3 className="subtitle-faleconosco">
                <u>{supportWhatsappNumberDisplay}</u>
              </h3>
            </a>
          </div>
        </div>

        <div className="col-12 col-lg-4 d-flex my-2 row">
          <div className="col-4 col-lg-4  d-flex align-items-center justify-content-center my-2">
            <a
              href={`mailto:${inventa_contact_email}`}
              target="_blank"
              rel="noreferrer"
            >
              <div
                id="icons-container"
                className="container-img-faleconosco d-flex align-items-center justify-content-center"
              >
                <img src={mailImg} className="icons" alt="E-mail icon" />
              </div>
            </a>
          </div>

          <div className="col-7 my-2 d-flex pl-1 flex-column justify-content-center align-items-start">
            <h3 className="subtitle-suporte d-block fs-4 fw-light text-black-50">
              E-mail
            </h3>
            <a
              href={`mailto:${inventa_contact_email}`}
              target="_blank"
              rel="noreferrer"
              className="text-decoration-none text-black-50"
            >
              <h3 className="subtitle-faleconosco text-black-150">
                <u>{inventa_contact_email}</u>
              </h3>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FooterSuporte;
